type Vec3 = readonly [number, number, number];

export interface SdfTheme {
  clearColor: Vec3;
  fillOutside: Vec3;
  fillInside: Vec3;
  strokeColor: Vec3;
  isoColor: Vec3;
}

export const LIGHT_SDF_THEME: SdfTheme = {
  clearColor: [0.985, 0.987, 0.992],
  fillOutside: [0.985, 0.987, 0.992],
  fillInside: [0.965, 0.970, 0.985],
  strokeColor: [0.30, 0.34, 0.43],
  isoColor: [0.56, 0.61, 0.74],
};

export const DARK_SDF_THEME: SdfTheme = {
  clearColor: [0.10, 0.11, 0.13],
  fillOutside: [0.10, 0.11, 0.13],
  fillInside: [0.16, 0.18, 0.21],
  strokeColor: [0.78, 0.82, 0.88],
  isoColor: [0.34, 0.42, 0.48],
};

// ── Isolines ──────────────────────────────────────────────────────────

/** Isolines per 1.0 SDF unit (d * FREQUENCY gives isoline-space) */
export const ISO_FREQUENCY = 11.0;

/** Half-width of each isoline band in isoline-space (= FREQUENCY-scaled d) */
export const ISO_HALF_WIDTH = 0.035;

/** Isoline mix intensity 0-1 */
export const ISO_INTENSITY = 0.42;

// ── Stroke ────────────────────────────────────────────────────────────

/** Half-width of the contour line in SDF space (total width = 2×) */
export const STROKE_HALF_WIDTH = 0.005;

